<template>
    <div :class="classObject">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: "messageBubble",
    props: {
	    isMine: {
		    type: Boolean,
		    default: true
	    },
	    type: {
	        type: [String, Number],
	        default: 1
	    }
    },
    data () {
        return {};
    },
    computed: {
	    classObject: function () {
	        return {
                'message-bubble-custom_initiator': !this.isMine && parseInt(this.type) === 1,
                'message-bubble-custom_receive': this.isMine && parseInt(this.type) === 1,
                'message-bubble-staff_receive': this.isMine && parseInt(this.type) === 2,
                'message-bubble-staff_initiator': !this.isMine && parseInt(this.type) === 2
	        }
	    }
    }
}
</script>

<style scoped lang="less">
.message-bubble-custom_initiator {
    margin-top: 8px;
    max-width: 268px;
    display: flex;
    align-items: center;
    width: fit-content;
    padding: 10px 12px;
    background-color: #FFFFFF;
    line-height: 22px;
    border-radius: 1px 16px 16px 16px;
    box-shadow: 0 2px 10px 0 #F0F5FA;
    position: relative;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 16px;
    color: #333333;
    letter-spacing: 0;
    flex-wrap: wrap;
}

.message-bubble-custom_receive {
    margin-top: 6px;
    max-width: 268px;
    display: flex;
    align-items: center;
    width: fit-content;
    padding: 10px 14px;
    background-color: #26C080;
    line-height: 22px;
    border-radius: 12px 0 12px 12px;
    position: relative;
    font-family: PingFangSC-Regular;
    font-size: 16px;
    color: #FFFFFF;
    font-weight: 400;
    letter-spacing: 0;
    flex-wrap: wrap;
}

.message-bubble-staff_receive {
    margin-right: 5px;
    max-width: 268px;
    display: flex;
    align-items: center;
    width: fit-content;
    padding: 7px 9px 8px 12px;
    background-color: #CAEFDC;
    line-height: 22px;
    border-radius: 4px 1px 4px 4px;
    position: relative;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 16px;
    color: #1E2226;
    letter-spacing: 0;
    flex-wrap: wrap;
}

.message-bubble-staff_receive::after {
    display: block;
    content: '';
    position: absolute;
    border-top: 4px solid #CAEFDC;
    border-bottom: 4px solid transparent;
    border-left: 4px solid transparent;
    border-right: 4px solid transparent;
    top: 0;
    right: -4px;
}

.message-bubble-staff_initiator {
    margin-top: 4px;
    max-width: 268px;
    display: flex;
    align-items: center;
    width: fit-content;
    padding: 10px;
    margin-right: 5px;
    background-color: #FFFFFF;
    line-height: 22px;
    border-radius: 1px 4px 4px 4px;
    position: relative;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 16px;
    color: #1E2226;
    letter-spacing: 0;
    flex-wrap: wrap;
}

.message-bubble-staff_initiator::after {
    display: block;
    content: '';
    position: absolute;
    border-top: 4px solid #FFFFFF;
    border-bottom: 4px solid transparent;
    border-left: 4px solid transparent;
    border-right: 4px solid transparent;
    top: 0;
    left: -4px;
}

</style>
